import React from 'react';

import Navigation from 'components/Navigation';

import './styles.css';

class PageWithoutSideMenu extends React.Component<{}> {
  render() {
    const {children} = this.props;

    return (
      <div className="PageWithoutSideMenuLayout">
        <Navigation className="PageWithoutSideMenuLayout__navigation" />
        <div className="PageWithoutSideMenuLayout__content">{children}</div>
      </div>
    );
  }
}

export default PageWithoutSideMenu;
